import abi from './abi.json'
const address = "0xe9e7cea3dedca5984780bafc599bd69add087d56"
const busd = {abi,address}
export default busd